import {ChangeDetectorRef, Component, Inject, OnDestroy } from '@angular/core';
import {Subject} from 'rxjs';
import {DateAdapter, MAT_DATE_FORMATS, MatDateFormats} from '@angular/material/core';
import {takeUntil} from 'rxjs/operators';
import {MatCalendar} from '@angular/material/datepicker';


@Component({
  selector: 'app-day-month-header',
  templateUrl: './day-month-header.component.html',
  styleUrls: ['./day-month-header.component.css']
})
export class DayMonthHeaderComponent<D> implements OnDestroy {

    private _destroyed = new Subject<void>();

    constructor(
        private _calendar: MatCalendar<D>, private _dateAdapter: DateAdapter<D>,
        @Inject(MAT_DATE_FORMATS) private _dateFormats: MatDateFormats, cdr: ChangeDetectorRef) {
        _calendar.stateChanges
            .pipe(takeUntil(this._destroyed))
            .subscribe(() => cdr.markForCheck());
    }

    ngOnDestroy() {
        this._destroyed.next();
        this._destroyed.complete();
    }

    get periodLabel() {
        return this._dateAdapter
            .format(this._calendar.activeDate, this._dateFormats.display.monthYearLabel)
            .toLocaleUpperCase();
    }

    previousClicked(mode: any) {
        this._calendar.activeDate = this._dateAdapter.addCalendarMonths(this._calendar.activeDate, -1);
    }

    nextClicked(mode: any) {
        this._calendar.activeDate =  this._dateAdapter.addCalendarMonths(this._calendar.activeDate, 1);
    }

}
